import { model, Schema } from "mongoose"
import { Item } from "../../types/enum/Item"
import { Pkm } from "../../types/enum/Pokemon"

export interface IHistoryEntry {
  date: string
  value: number
}

export interface IItemsStatisticV2 {
  tier: string
  items: Record<string, IItemV2>
}

export interface IItemV2 {
  rank: number
  count: number
  name: Item
  pokemons: Pkm[]
  rank_history?: IHistoryEntry[]
  count_history?: IHistoryEntry[]
}

const historyEntrySchema = new Schema(
  {
    date: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    }
  },
  { _id: false }
)

const pokemonsStatistic = new Schema({
  tier: {
    type: String
  },
  items: {
    type: Map,
    of: {
      rank: {
        type: Number
      },
      count: {
        type: Number
      },
      name: {
        type: String,
        enum: Item
      },
      pokemons: [
        {
          type: String,
          enum: Object.values(Pkm)
        }
      ],
      rank_history: {
        type: [historyEntrySchema],
        default: []
      },
      count_history: {
        type: [historyEntrySchema],
        default: []
      }
    }
  }
})

export default model<IItemsStatisticV2>(
  "ItemsStatisticV2",
  pokemonsStatistic,
  "items-statistic-v2"
)

export async function fetchMetaItems(): Promise<IItemsStatisticV2[]> {
  return fetch("/meta/items").then((res) => res.json())
}
